import { ErrorBoundary } from 'react-error-boundary';
import { DisclaimerPanel } from './DisclaimerPanel';
import { DisclaimerPanelError } from './DisclaimerPanelError';

export const SafeDisclaimerPanel = () => {
  return <ErrorBoundary FallbackComponent={DisclaimerPanelError}>
    <DisclaimerPanel></DisclaimerPanel>
  </ErrorBoundary>
}